import React from 'react';
import ReactDOM from 'react-dom';

import 'root-size'; // rem自适应布局
import '../components/reset-css'; // 一些基本的样式重置
import '../icons/index.css'; // icons样式

import {Provider} from 'react-redux';
import store from '../store';
import Detector from '../utils/detector'; // 客户端识别函数
import $ from 'zzc-zepto';

import InitConfig from '../components/statistics/config'; // 数据统计
InitConfig();
$(document.body).addClass(`${Detector.os.name} ${Detector.browser.name}`); // body加上app标识类名，如"android tantumap"

// for test
setTimeout(() => {
  console.log(store.getState());
}, 1000);

export default function render(Page) {

  ReactDOM.render((
    <Provider store={store}>
      <Page />
    </Provider>
  ), document.getElementById('root'));
}






// WEBPACK FOOTER //
// ./src/pages/render.js